import React, { Component } from 'react';
import styled from 'styled-components';
import { fmt } from '../model/dashboardCalc';

const W = 740;
const H = 260;
const L = 43;
const R = 15;
const T = 18;
const B = 33;

// 단일 시리즈 영역 차트 (forecast=true 이면 45% 이후 구간을 예측 점선으로 표시)
class LineChart extends Component {
  render() {
    const { id, values, labels, forecast, ariaLabel } = this.props;
    const max = Math.max(...values, 1) * 1.16;
    const x = (i) => L + ((W - L - R) * i) / Math.max(values.length - 1, 1);
    const y = (v) => H - B - ((H - T - B) * v) / max;
    const split = forecast ? Math.floor(values.length * 0.45) : values.length;
    const line = (a, b) =>
      values
        .slice(a, b)
        .map((v, j) => `${j === 0 ? 'M' : 'L'}${x(j + a).toFixed(1)} ${y(v).toFixed(1)}`)
        .join(' ');

    const path = line(0, split);
    const pred = forecast ? line(split - 1, values.length) : '';
    const area = `${path} L${x(split - 1)} ${H - B} L${x(0)} ${H - B} Z`;
    const gradientId = `${id}AreaGradient`;
    const labelStep = Math.ceil(labels.length / 7);

    return (
      <Svg viewBox={`0 0 ${W} ${H}`} role="img" aria-label={ariaLabel}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#399cfa" stopOpacity=".23" />
            <stop offset="1" stopColor="#399cfa" stopOpacity="0" />
          </linearGradient>
        </defs>
        {[0, 1, 2, 3, 4].map((k) => {
          const v = (max * k) / 4;
          const yy = y(v);
          return (
            <g key={`tick-${k}`}>
              <line className="axis" x1={L} y1={yy} x2={W - R} y2={yy} />
              <text x={L - 9} y={yy + 4} textAnchor="end">
                {fmt(v, 0)}
              </text>
            </g>
          );
        })}
        {labels.map((label, i) =>
          i % labelStep === 0 || i === labels.length - 1 ? (
            <text key={`label-${i}`} x={x(i)} y={H - 10} textAnchor="middle">
              {label}
            </text>
          ) : null
        )}
        <path d={area} fill={`url(#${gradientId})`} />
        <path className="series" d={path} />
        {pred && <path className="pred" d={pred} />}
        <circle cx={x(split - 1)} cy={y(values[split - 1])} r="4" fill="#7ac6ff" />
      </Svg>
    );
  }
}

const Svg = styled.svg`
  width: 100%;
  height: 255px;
  display: block;
  overflow: visible;

  text {
    font-size: 11px;
    fill: #849bb9;
  }
  .axis {
    stroke: #273a52;
    stroke-width: 1;
  }
  .series {
    fill: none;
    stroke: #5ebcff;
    stroke-width: 3;
    stroke-linejoin: round;
    stroke-linecap: round;
  }
  .pred {
    fill: none;
    stroke: #f4c368;
    stroke-width: 2.5;
    stroke-dasharray: 6 5;
  }

  @media (max-width: 700px) {
    height: auto;
    min-height: 180px;
    max-height: 250px;
  }
`;

export default LineChart;
